export default "__VITE_ASSET__BowkrkXL__"